/* unplugin-vue-components disabled */import { render } from "./train.vue?vue&type=template&id=06ca7132&scoped=true&ts=true"
import script from "./train.vue?vue&type=script&lang=ts"
export * from "./train.vue?vue&type=script&lang=ts"

import "./train.vue?vue&type=style&index=0&id=06ca7132&lang=scss&scoped=true"

import exportComponent from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06ca7132"]])

export default __exports__